import React, { Component } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { NavLink, HashRouter } from "react-router-dom";

class Footer extends React.Component {
  render() {
    return (
      <HashRouter>
        <div>
          <Navbar bg="light">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link>
                  <NavLink to="/imprint" className="Links">
                    Impressum
                  </NavLink>
                </Nav.Link>
                <Nav.Link>
                  <NavLink to="/privacy-policy" className="Links">
                    Datenschutzerklärung
                  </NavLink>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </HashRouter>
    );
  }
}
export default Footer;
